import { getFeatureToggleClient } from 'infra/featureToggles'

export default function isPendingJobsEnabled(): boolean {
  return getFeatureToggleClient().variation(
    'WorkPortal.PendingJobsEnabled',
    false,
  )
}
